export const verificationTypes = [
  { label: "Base de datos", value: "DATABASE" },
  { label: "Bitácoras", value: "LOG" },
  { label: "Capturas de pantalla", value: "SCREENSHOTS" },
  { label: "Carta", value: "LETTER" },
  { label: "Certificados", value: "CERTIFICATE" },
  { label: "Contrato", value: "CONTRACT" },
  { label: "Convenios", value: "AGREEMENTS" },
  { label: "Cuestionarios", value: "QUESTIONNAIRES" },
  { label: "Curriculas", value: "CURRICULUMS" },
  { label: "Diagnóstico", value: "DIAGNOSTIC" },
  { label: "Diplomas", value: "DIPLOMA" },
  { label: "Encuestas", value: "SURVEY" },
  { label: "Estadísticas", value: "STATISTICS" },
  { label: "Evaluaciones", value: "EVALUATIONS" },
  { label: "Expediente", value: "RECORD" },
  { label: "Fichas descriptivas", value: "DESCRIPTIVE_TAGS" },
  { label: "Formato", value: "FORMAT" },
  { label: "Listas de asistencia", value: "ATTENDANCE_LIST" },
  { label: "Memoria fotográfica", value: "PHOTOGRAPHIC_MEMORY" },
  { label: "Minutas de reuniones", value: "MEETING_NOTES" },
  { label: "Notas periodísticas", value: "JOURNALIST_NOTES" },
  { label: "Oficios", value: "DOCUMENTS" },
  { label: "Planes de intervención individual", value: "INTERVENTION_PLANS" },
  { label: "Protocolo", value: "PROTOCOL" },
  { label: "Publicación", value: "POST" },
  { label: "Reporte/Informe", value: "REPORT_DOC" },
  { label: "Testimonio", value: "TESTIMONIAL" },
  { label: "Valoración psicológica", value: "PSYCH_EVAL" },
  { label: "Videos", value: "VIDEOS" }
]
